<app-new-modal-message
  #modalMensagem
  [showFecharBtn]="false"
  mensagem="Erro obtendo os dados da Origem"
  titulo="Erro!"
></app-new-modal-message>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div class="row">
  <form [formGroup]="detalhesClienteForm" class="col-xs-12 forms">
    <div class="info-container">
      <h2>Detalhes do Cliente</h2>

      <div class="form-group">
        <span class="icon conjuge"></span>
        <div class="inputs">
          <label for="nomeCliente">Nome</label>
          <input
            class="form-control"
            type="text"
            placeholder="Nome e Sobrenome"
            maxlength="60"
            required
            appShowErrorMessages
            requiredMessage="O campo Nome é obrigatório"
            formControlName="nomeCliente"
            name="nomeCliente"
          />
          <div *ngIf="showMensagemNomeCliente" class="text-danger">
            Informação inválida, números não são permitidos.
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon email"></span>
        <div class="inputs">
          <label for="emailCliente">Email</label>
          <input
            class="form-control"
            type="email"
            placeholder="exemplo@email.com.br"
            maxlength="60"
            [email]="true"
            appEmailValidator
            appShowErrorMessages
            required
            formControlName="emailCliente"
            name="emailCliente"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon celular-cliente"></span>
        <div class="inputs">
          <label for="telefonesCliente">Celular</label>
          <input
            class="form-control"
            type="text"
            placeholder="(00) 00000-0000"
            required
            [minLength]="10"
            [maxLength]="11"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            requiredMessage="Preencha o campo Celular para enviar o token de segurança!"
            formControlName="telefoneCelularCliente"
            name="telefoneCelularCliente"
            appOnlyNumberRestrictive
            appDDDtelefone
            [value]="
              detalhesClienteForm.get('telefoneCelularCliente').value | telefone
            "
            autocomplete="off"
          />
        </div>
      </div>

        <div class="form-group" *ngIf="showValidacaoCelular">
          <span class="icon seguranca"></span>
          <div class="inputs">
            <label for="telefoneCelularCliente" class="mb-16">Verificação de segurança</label>
            <app-timer-token
              [onSolicitarToken]="solicitarToken()"
              [onValidarToken]="validarToken()"
              (onSuccessValidate)="handleConfirmacaoSuccess()">
            </app-timer-token>
            <div class="importante-info">
              <span class="icon warning icone-laranja"></span>
              <span>
                <strong>ATENÇÃO:</strong> Precisamos enviar um token de
                segurança ao cliente para confirmar se este é seu celular
                pessoal, permitindo realizar a Assinatura Digital e ser
                contatado para qualquer fim no futuro.
              </span>
            </div>
          </div>
        </div>

     <div class="form-group" *ngIf="showValidacaoBiometria">
        <span class="icon seguranca"></span>
        <div class="inputs">
          <label for="telefoneCelularCliente" class="mb-16"
            >Autenticação do Cliente | Validação de Celular, Aceite de termos e
            Biometria
          </label>

          <button
            class="btn btn-full-orange mx-0"
            (click)="enviarLinkParaAutenticacao()"
            [ngClass]="{ 'btn-green': linkAutenticacaoEnviado }"
            [disabled]="linkAutenticacaoEnviado"
          >
            <ng-container
              *ngIf="!linkAutenticacaoEnviado; else linkEnviadoTemplate"
            >
              Enviar Link para celular
            </ng-container>

            <ng-template #linkEnviadoTemplate>
              <span class="icon token"></span>Link enviado!
            </ng-template>
          </button>

          <div *ngIf="!linkAutenticacaoEnviado" class="importante-info">
            <span class="icon warning icone-laranja"></span>
            <div class="text">
              <span class="text-orange">ATENÇÃO:</span> Precisamos garantir que
              o cliente confirme as permissões de LGPD, SCR e tire uma foto do
              seu rosto (selfie). <br /><span class="text-red">
                Esta etapa é obrigatória e não será possível formalizar a
                proposta sem as autorizações e foto do cliente.</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon mundo"></span>
        <div class="inputs">
          <label for="nacionalidadeCliente">Nacionalidade</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Nacionalidade é obrigatório"
            name="nacionalidadeCliente"
            formControlName="nacionalidadeCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let nacionalidade of nacionalidades"
              value="{{ nacionalidade.id }}"
            >
              {{ nacionalidade.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon genero"></span>
        <div class="inputs">
          <label for="generoCliente">Gênero</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Gênero é obrigatório"
            name="generoCliente"
            formControlName="generoCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option value="F">FEMININO</option>
            <option value="M">MASCULINO</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon estado-civil"></span>
        <div class="inputs">
          <label for="estadoCivilCliente">Estado Civil</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Estado Civil é obrigatório"
            name="estadoCivilCliente"
            formControlName="estadoCivilCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let estadoCivil of estadosCivis"
              value="{{ estadoCivil.codigo }}"
            >
              {{ estadoCivil.descricao }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div
      class="info-container blue-box"
      [formGroup]="conjugeForm"
      *ngIf="showFormularioConjuge"
    >
      <h2>Informações do Cônjuge</h2>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="cpfConjuge">CPF</label>
          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            mask-number
            mask="999.999.999-99"
            formControlName="cpf"
            name="cpfConjuge"
            readonly
          />
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="dataNascimentoConjuge">Data de Nascimento</label>
          <input
            class="form-control"
            type="text"
            mask-number
            mask="99/99/9999"
            placeholder="00/00/0000"
            formControlName="dataNascimento"
            name="dataNascimentoConjuge"
            readonly
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon classe-profissional"></span>
        <div class="inputs">
          <label for="classeProfissionalConjuge">Classe Profissional</label>
          <select
            class="form-control"
            appShowErrorMessages
            required
            requiredMessage="O campo Classe Profissional é obrigatório"
            name="classeProfissionalConjuge"
            formControlName="classeProfissionalConjuge"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let classe of classesProfissionaisConjuge"
              value="{{ classe.id }}"
            >
              {{ classe.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon profissao"></span>
        <div class="inputs">
          <label for="profissaoConjuge">Profissão</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Profissão é obrigatório"
            name="profissaoConjuge"
            formControlName="profissaoConjuge"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let profissao of profissoesConjuge"
              value="{{ profissao.id }}"
            >
              {{ profissao.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group mb-0" *ngIf="isExibeEmpresaConjuge">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="empresaConjuge">Nome da empresa</label>
          <input
            class="form-control"
            type="text"
            maxlength="40"
            placeholder="Empresa"
            formControlName="empresaConjuge"
            name="empresaConjuge"
            required
          />
        </div>
      </div>
    </div>

    <div class="info-container">
      <div formGroupName="filiacao">
        <div class="form-group">
          <span class="icon filiacao"></span>
          <div class="inputs">
            <label for="nomeDaMae">Nome da Mãe</label>
            <input
              id="nomeDaMae"
              name="nomeDaMae"
              formControlName="nomeMae"
              class="form-control"
              type="text"
              maxlength="60"
              placeholder="Insira o nome completo da sua mãe..."
              [required]="true"
              appShowErrorMessages
              requiredMessage="O campo Nome da Mãe é obrigatório"
            />
          </div>
        </div>

        <div class="form-group">
          <span class="icon vazio"></span>

          <div class="inputs">
            <div class="box-label">
              <label for="nomeDoPai">Nome do Pai</label>
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                texto="Campo não obrigatório!"
              ></saiba-mais>
            </div>

            <input
              id="nomeDoPai"
              class="form-control"
              type="text"
              maxlength="60"
              placeholder="Insira o nome completo do seu pai..."
              name="nomeDoPai"
              formControlName="nomePai"
            />

            <div class="mt-12">
              <div class="check-mod">
                <label for="sem-filiacao" class="label-checkbox">
                  <input
                    id="sem-filiacao"
                    type="checkbox"
                    name="semFiliacao"
                    class="input-checkbox"
                    formControlName="semFiliacao"
                  />
                  <span class="radio-label pr-20"
                    >Sem Mãe ou Pai no registro</span
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon profissao"></span>
        <div class="inputs">
          <label for="profissaoCliente">Profissão</label>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Profissão é obrigatório"
            name="profissaoCliente"
            formControlName="profissaoCliente"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let profissao of profissoes"
              value="{{ profissao.id }}"
            >
              {{ profissao.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group" *ngIf="isExibeEmpresa">
        <span class="icon predio"></span>
        <div class="inputs">
          <label for="empresaCliente">Empresa</label>
          <input
            class="form-control"
            type="text"
            maxlength="40"
            placeholder="Digite o nome da empresa em que trabalha"
            required
            appShowErrorMessages
            requiredMessage="O campo Nome da Empresa é obrigatório"
            formControlName="empresaCliente"
            name="empresaCliente"
          />
        </div>
      </div>
      <div class="form-group">
        <span class="icon politico"></span>
        <div class="inputs">
          <label for="cargoPoliticoCliente" class="mb-8"
            >Politicamente Exposto?</label
          >
          Exerceu cargo político nos últimos 5 anos ou é parente de algum?
          <div class="mt-12">
            <div class="check-mod">
              <label for="isPoliticamenteExposto">
                <input
                  type="radio"
                  name="isPoliticamenteExposto"
                  formControlName="isPoliticamenteExposto"
                  value="true"
                />
                <span class="radio-label pr-20">Sim</span>
                <input
                  type="radio"
                  name="isPoliticamenteExposto"
                  formControlName="isPoliticamenteExposto"
                  value="false"
                  selected
                />
                <span class="radio-label">Não</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon politico"></span>
        <div class="inputs">
          <label for="fatca-titulo" class="mb-8"
            >FATCA</label
          >
          Você possui obrigação fiscal com os Estados Unidos da América ou seus territórios?
          <div class="mt-12">
            <div class="check-mod">
              <label for="fatca">
                <input
                  type="radio"
                  name="fatca"
                  formControlName="fatca"
                  value="S"
                />
                <span class="radio-label pr-20">Sim</span>
                <input
                  type="radio"
                  name="fatca"
                  formControlName="fatca"
                  value="N"
                  selected
                />
                <span class="radio-label">Não</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <footer class="footer-cdc">
    <app-botao-navegacao-clean
      (previous)="onClickPrevious()"
      (next)="onClickNext()"
      [previousShow]="false"
      [nextShow]="true"
      [nextEnabled]="formValid && nomeClienteValido"
    >
    </app-botao-navegacao-clean>
  </footer>
</div>
